module.exports = __webpack_public_path__ + "img/logo2.0219b12b.png";